import { render, staticRenderFns } from "./ItensDashboardModal.vue?vue&type=template&id=4655550c&scoped=true"
import script from "./ItensDashboardModal.vue?vue&type=script&lang=js"
export * from "./ItensDashboardModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4655550c",
  null
  
)

export default component.exports